// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2spf3","colBig":"styles_colBig__EeCgj","colSmall":"styles_colSmall__3quEm","shopifyNameWrapper":"styles_shopifyNameWrapper__1vtyO"};